import H5P from 'imports-loader?H5PIntegration=>window.parent.H5PIntegration!H5P';
import 'H5PEventDispatcher';
import 'H5PxAPI';
import 'H5PxAPIEvent';
import 'H5PContentType';
import 'H5PConfirmationDialog';
import 'H5PRequestQueue';
import 'H5PActionBar';

export default H5P;